import PropTypes from 'prop-types'
import React from 'react'
import classnames from 'classnames'
import './flexgrid.css'

const FlexGrid = props => {
  const styles = {
    justifyContent: props.justifyContent,
    alignItems: props.alignItems,
    alignContent: props.alignContent,
    flexDirection: props.direction,
    flexWrap: props.wrap,
    ...props.style
  }

  if (props.fillHeight) {
    styles.height = '100%'
  }

  const className = classnames({
    FlexGrid: true,
    [props.className]: !!props.className
  })

  return <div className={className} style={styles}>{props.children}</div>
}

FlexGrid.propTypes = {
  justifyContent: PropTypes.string,
  alignItems: PropTypes.string,
  alignContent: PropTypes.string,
  direction: PropTypes.string,
  wrap: PropTypes.string,
  fillHeight: PropTypes.bool,
  class: PropTypes.string,
  style: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.oneOfType([ PropTypes.object, PropTypes.array ])
}

FlexGrid.displayName = 'FlexGrid'

const FlexItem = props => {
  const style = {
    flex: props.flex,
    marginLeft: `${props.space || props.spaceLeft}px`,
    marginRight: `${props.space || props.spaceRight}px`,
    width: props.width ? `${props.width}px` : 'auto',
    textAlign: props.align,
    order: props.order,
    alignSelf: props.alignSelf
  }
  const className = classnames({
    FlexItem: true,
    [props.className]: !!props.className
  })
  return <div className={className} style={style}>{props.children}</div>
}

FlexItem.defaultProps = {
  flex: 'initial',
  spaceLeft: 0,
  spaceRight: 0
}

FlexItem.propTypes = {
  flex: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
  space: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
  spaceLeft: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
  spaceRight: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
  width: PropTypes.oneOfType([ PropTypes.number, PropTypes.string ]),
  align: PropTypes.string,
  order: PropTypes.string,
  alignSelf: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.any
}

FlexItem.displayName = 'FlexItem'

export { FlexGrid, FlexItem }



// WEBPACK FOOTER //
// ./ui/flexgrid.js